<script setup lang="ts">
import SolidMessageChatCircle from '@docue/docue-ui-v2/icons/SolidMessageChatCircle.vue'

defineOptions({ inheritAttrs: false })

const { showIntercom } = useSubscriptionProcessContext()

const { t } = useI18n()
const { country } = useAuth()
const { data: storyBlokConfig } = useQueryStoryblok.getAppConfig({
  country,
})

const salesPeopleImageSource = computed(() => storyBlokConfig.value?.story.content.subscribe_modal_people?.filename)

const isContactUsModalOpen = ref(false)
</script>

<template>
  <ContactUsModal
    v-if="isContactUsModalOpen"
    v-model="isContactUsModalOpen"
  />

  <div
    v-bind="$attrs"
    class="space-y-3 rounded-lg border border-gray-300 p-6"
  >
    <img
      v-if="salesPeopleImageSource"
      :src="salesPeopleImageSource"
      class="w-40"
    >

    <span class="inline-flex gap-3">
      <SolidMessageChatCircle class="size-5 shrink-0 text-gray-800" />
      <i18n-t
        class="text-sm"
        keypath="subscribe.helpCta.content"
        tag="span"
      >
        <template #chat>
          <button
            class="inline font-semibold text-gray-800 underline hover:text-gray-600 active:text-gray-800"
            @click="showIntercom()"
          >
            {{ t('subscribe.helpCta.chat') }}
          </button>
        </template>

        <template #contactRequest>
          <button
            class="inline font-semibold text-gray-800 underline hover:text-gray-600 active:text-gray-800"
            @click="isContactUsModalOpen = true"
          >
            {{ t('subscribe.helpCta.contactRequest') }}
          </button>
        </template>
      </i18n-t>
    </span>
  </div>
</template>
